import { Collapse, Row, Col, Tooltip, Input, Form } from "antd";
import React, { createRef, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { CollapseComponent } from "../../../components/Collapse";
import NumberOfCasesStore from "../../../DataStores/NumberOfCasesStore";
import { inject, observer } from "mobx-react";

import "../../../styles/components.scss";
import { dataSuperior, dataSuperior0 } from "../../../utils/Utils";
const { Panel } = Collapse;

const NumberOfCases = ({ ToolStore, displayAll }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue(NumberOfCasesStore.toFormatJson());
  }, [NumberOfCasesStore.data, ToolStore.numbersToTest, ToolStore.conditions]);

  const toGetElement = (first, second) => {
    var element = NumberOfCasesStore.getData()[0]
      .value.filter((a) => a.fieldName == first)[0]
      .value.filter((b) => b.fieldName == second)[0];
    return element;
  };

  const onChange = (first, e) => {
    if (!NumberOfCasesStore.changed[first]) {
      var json = form.getFieldsValue();
      json[first] = parseFloat(e.nativeEvent.data);
      form.setFieldsValue(json);
    }
    const c = { ...NumberOfCasesStore.changed };
    c[first] = true;
    NumberOfCasesStore.setChanged(c);
  };
  const toGetSubElements = (element) => {
    var items = [];

    element.value.forEach((e) => {
      if ((e.display != -1 && e.display) || displayAll) {
        items.push(e);
      }
    });
    return items;
  };

  const onBlur = (ev, id) => {
    if (ev.target.value == "") {
      var json = form.getFieldsValue();
      json[id] = NumberOfCasesStore.defaultsValues[id];
      form.setFieldsValue(json);
      const c = { ...NumberOfCasesStore.changed };

      c[id] = false;
      NumberOfCasesStore.setChanged(c);
      NumberOfCasesStore.toUpdateNumberOfCases(form.getFieldsValue());
    }
  };

  const generalElements = () => {
    const newPatientOneYear = toGetElement("general", "newPatientOneYear");

    const avgTreatment = toGetElement("general", "avgTreatment");

    const newAlignersTreatement = toGetElement(
      "general",
      "newAlignersTreatement"
    );
    const newBraces = toGetElement("general", "newBraces");
    const newAlignersItems = toGetSubElements(newAlignersTreatement);
    const newBracesItems = toGetSubElements(newBraces);
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="general" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="newPatientOneYearTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="newPatientOneYear" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="newPatientOneYear"
                      rules={[{ validator: dataSuperior }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          newPatientOneYear.suffix && newPatientOneYear.suffix
                        }
                        prefix={
                          newPatientOneYear.prefix && newPatientOneYear.prefix
                        }
                        className={
                          !NumberOfCasesStore.changed.newPatientOneYear &&
                          "roi--input-default"
                        }
                        onChange={(e) => onChange("newPatientOneYear", e)}
                        onBlur={(e) => onBlur(e, "newPatientOneYear")}
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="avgTreatmentTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="avgTreatment" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="avgTreatment"
                      rules={[{ validator: dataSuperior }]}
                    >
                      <Input
                        type="number"
                        suffix={avgTreatment.suffix && avgTreatment.suffix}
                        prefix={ToolStore.symbol}
                        onChange={(e) => onChange("avgTreatment", e)}
                        onBlur={(e) => onBlur(e, "avgTreatment")}
                        className={
                          !NumberOfCasesStore.changed.avgTreatment &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>{" "}
            </Row>{" "}
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="newAlignersTreatementTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="newAlignersTreatement" />
                    </span>
                  </Col>
                  {newAlignersItems.length == 1 && (
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="newAlignersTreatementadults"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={
                            newAlignersItems[0].suffix &&
                            newAlignersItems[0].suffix
                          }
                          prefix={
                            newAlignersItems[0].prefix &&
                            newAlignersItems[0].prefix
                          }
                          className={
                            !NumberOfCasesStore.changed
                              .newAlignersTreatementadults &&
                            "roi--input-default"
                          }
                          onChange={(e) =>
                            onChange("newAlignersTreatementadults", e)
                          }
                          onBlur={(e) =>
                            onBlur(e, "newAlignersTreatementadults")
                          }
                        ></Input>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                {newAlignersItems.length > 1 && (
                  <>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col xl={2} md={2} />
                      <Col xl={14} md={12}>
                        <span className="roi--label-section roi--border-adults">
                          <FormattedMessage id="adults" />
                        </span>
                      </Col>
                      <Col xl={8} md={6}>
                        <Form.Item
                          name="newAlignersTreatementadults"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            prefix={newAlignersItems[0].prefix}
                            suffix={newAlignersItems[0].suffix}
                            className={
                              !NumberOfCasesStore.changed
                                .newAlignersTreatementadults &&
                              "roi--input-default"
                            }
                            onBlur={(e) =>
                              onBlur(e, "newAlignersTreatementadults")
                            }
                            onChange={(e) =>
                              onChange("newAlignersTreatementadults", e)
                            }
                            type="number"
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col xl={2} md={2} />
                      <Col xl={14} md={12}>
                        <span className="roi--label-section roi--border-adults">
                          <FormattedMessage id="teens" />
                        </span>
                      </Col>
                      <Col xl={8} md={6}>
                        <Form.Item
                          name="newAlignersTreatementteens"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            prefix={newAlignersItems[1].prefix}
                            suffix={newAlignersItems[1].suffix}
                            className={
                              !NumberOfCasesStore.changed
                                .newAlignersTreatementteens &&
                              "roi--input-default"
                            }
                            onBlur={(e) =>
                              onBlur(e, "newAlignersTreatementteens")
                            }
                            onChange={(e) =>
                              onChange("newAlignersTreatementteens", e)
                            }
                            type="number"
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                )}
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="newBracesTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="newBraces" />
                    </span>
                  </Col>
                  {newBracesItems.length == 1 && (
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="newBracesadults"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={
                            newBracesItems[0].suffix && newBracesItems[0].suffix
                          }
                          prefix={
                            newBracesItems[0].prefix && newBracesItems[0].prefix
                          }
                          className={
                            !NumberOfCasesStore.changed.newBracesadults &&
                            "roi--input-default"
                          }
                          onBlur={(e) => onBlur(e, "newBracesadults")}
                          onChange={(e) => onChange("newBracesadults", e)}
                        ></Input>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
                <>
                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="adults" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="newBracesadults"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={newBracesItems[0].prefix}
                          suffix={newBracesItems[0].suffix}
                          className={
                            !NumberOfCasesStore.changed.newBracesadults &&
                            "roi--input-default"
                          }
                          onBlur={(e) => onBlur(e, "newBracesadults")}
                          onChange={(e) => onChange("newBracesadults", e)}
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="teens" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="newBracesteens"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={newBracesItems[1].prefix}
                          suffix={newBracesItems[1].suffix}
                          className={
                            !NumberOfCasesStore.changed.newBracesteens &&
                            "roi--input-default"
                          }
                          onBlur={(e) => onBlur(e, "newBracesteens")}
                          onChange={(e) => onChange("newBracesteens", e)}
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    var display = false;
    if (
      (newPatientOneYear.display && newPatientOneYear.display != -1) ||
      (avgTreatment.display != -1 && avgTreatment.display)
    ) {
      display = true;
    }
    if (
      (newPatientOneYear.display && newPatientOneYear.display != -1) ||
      (avgTreatment.display != -1 && avgTreatment.display) ||
      (ToolStore.conditions.monitoringAligners &&
        newAlignersItems.length > 0) ||
      (ToolStore.conditions.monitoringBraces && newBracesItems.length > 0)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="general" />
                </span>
              </Row>
            }
            key="1"
          >
            {display && (
              <Row>
                {newPatientOneYear.display && newPatientOneYear.display != -1 && (
                  <>
                    {" "}
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="newPatientOneYearTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="newPatientOneYear" />
                          </span>
                        </Col>
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="newPatientOneYear"
                            rules={[{ validator: dataSuperior }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                newPatientOneYear.suffix &&
                                newPatientOneYear.suffix
                              }
                              prefix={
                                newPatientOneYear.prefix &&
                                newPatientOneYear.prefix
                              }
                              className={
                                !NumberOfCasesStore.changed.newPatientOneYear &&
                                "roi--input-default"
                              }
                              onChange={(e) => onChange("newPatientOneYear", e)}
                              onBlur={(e) => onBlur(e, "newPatientOneYear")}
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
                {avgTreatment.display && avgTreatment.display != -1 && (
                  <Col xl={10} md={24} xs={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={<FormattedMessage id="avgTreatmentTooltip" />}
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="avgTreatment" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="avgTreatment"
                          rules={[{ validator: dataSuperior }]}
                        >
                          <Input
                            type="number"
                            suffix={avgTreatment.suffix && avgTreatment.suffix}
                            prefix={ToolStore.symbol}
                            onChange={(e) => onChange("avgTreatment", e)}
                            onBlur={(e) => onBlur(e, "avgTreatment")}
                            className={
                              !NumberOfCasesStore.changed.avgTreatment &&
                              "roi--input-default"
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
            )}
            <Row>
              {ToolStore.conditions.monitoringAligners &&
                newAlignersItems.length > 0 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="newAlignersTreatementTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="newAlignersTreatement" />
                          </span>
                        </Col>
                        {newAlignersItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="newAlignersTreatementadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  newAlignersItems[0].suffix &&
                                  newAlignersItems[0].suffix
                                }
                                prefix={
                                  newAlignersItems[0].prefix &&
                                  newAlignersItems[0].prefix
                                }
                                className={
                                  !NumberOfCasesStore.changed
                                    .newAlignersTreatementadults &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange("newAlignersTreatementadults", e)
                                }
                                onBlur={(e) =>
                                  onBlur(e, "newAlignersTreatementadults")
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                      {newAlignersItems.length > 1 && (
                        <>
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="newAlignersTreatementadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={newAlignersItems[0].prefix}
                                  suffix={newAlignersItems[0].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .newAlignersTreatementadults &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "newAlignersTreatementadults")
                                  }
                                  onChange={(e) =>
                                    onChange("newAlignersTreatementadults", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="newAlignersTreatementteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={newAlignersItems[1].prefix}
                                  suffix={newAlignersItems[1].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .newAlignersTreatementteens &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "newAlignersTreatementteens")
                                  }
                                  onChange={(e) =>
                                    onChange("newAlignersTreatementteens", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )}
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
              {ToolStore.conditions.monitoringBraces &&
                newBracesItems.length > 0 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={<FormattedMessage id="newBracesTooltip" />}
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="newBraces" />
                          </span>
                        </Col>
                        {newBracesItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="newBracesadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  newBracesItems[0].suffix &&
                                  newBracesItems[0].suffix
                                }
                                prefix={
                                  newBracesItems[0].prefix &&
                                  newBracesItems[0].prefix
                                }
                                className={
                                  !NumberOfCasesStore.changed.newBracesadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) => onBlur(e, "newBracesadults")}
                                onChange={(e) => onChange("newBracesadults", e)}
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                      {newBracesItems.length > 1 && (
                        <>
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="newBracesadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={newBracesItems[0].prefix}
                                  suffix={newBracesItems[0].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .newBracesadults && "roi--input-default"
                                  }
                                  onBlur={(e) => onBlur(e, "newBracesadults")}
                                  onChange={(e) =>
                                    onChange("newBracesadults", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="newBracesteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={newBracesItems[1].prefix}
                                  suffix={newBracesItems[1].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .newBracesteens && "roi--input-default"
                                  }
                                  onBlur={(e) => onBlur(e, "newBracesteens")}
                                  onChange={(e) =>
                                    onChange("newBracesteens", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        </>
                      )}
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };

  const alignerCasesElements = () => {
    const averagePrice = toGetElement("alignersCases", "averagePrice");
    const addFeeAligners = toGetElement("alignersCases", "addFeeAligners");
    const averagePriceItems = toGetSubElements(averagePrice);
    const addFeeAlignersItems = toGetSubElements(addFeeAligners);
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="alignersCases" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="averagePriceTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="averagePrice" />
                    </span>
                  </Col>
                </Row>
                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="averagePriceadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={ToolStore.symbol}
                        suffix={averagePriceItems[0].suffix}
                        className={
                          !NumberOfCasesStore.changed.averagePriceadults &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "averagePriceadults")}
                        onChange={(e) => onChange("averagePriceadults", e)}
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="averagePriceteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={ToolStore.symbol}
                        suffix={averagePriceItems[1].suffix}
                        className={
                          !NumberOfCasesStore.changed.averagePriceteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "averagePriceteens")}
                        onChange={(e) => onChange("averagePriceteens", e)}
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="addFeeAlignersTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="addFeeAligners" />
                    </span>
                  </Col>
                </Row>
                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="addFeeAlignersadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={ToolStore.symbol}
                        suffix={addFeeAlignersItems[0].suffix}
                        className={
                          !NumberOfCasesStore.changed.addFeeAlignersadults &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "addFeeAlignersadults")}
                        onChange={(e) => onChange("addFeeAlignersadults", e)}
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="addFeeAlignersteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={ToolStore.symbol}
                        suffix={addFeeAlignersItems[1].suffix}
                        className={
                          !NumberOfCasesStore.changed.addFeeAlignersteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "addFeeAlignersteens")}
                        onChange={(e) => onChange("addFeeAlignersteens", e)}
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    if (averagePriceItems.length > 0 || addFeeAlignersItems.length > 0) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="alignersCases" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {averagePriceItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={<FormattedMessage id="averagePriceTooltip" />}
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="averagePrice" />
                        </span>
                      </Col>
                      {ToolStore.numbersToTest.w24 > 0 &&
                        averagePriceItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="averagePriceadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                prefix={ToolStore.symbol}
                                className={
                                  !NumberOfCasesStore.changed
                                    .averagePriceadults && "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange("averagePriceadults", e)
                                }
                                onBlur={(e) => onBlur(e, "averagePriceadults")}
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {ToolStore.conditions.separateTeensAdults &&
                        ToolStore.numbersToTest.w25 > 0 &&
                        averagePriceItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="averagePriceteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  averagePriceItems[0].suffix &&
                                  averagePriceItems[0].suffix
                                }
                                prefix={ToolStore.symbol}
                                className={
                                  !NumberOfCasesStore.changed
                                    .averagePriceaverage && "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange("averagePriceteens", e)
                                }
                                onBlur={(e) => onBlur(e, "averagePriceteens")}
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {averagePriceItems.length > 1 && (
                      <>
                        {ToolStore.numbersToTest.w24 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="averagePriceadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  suffix={averagePriceItems[0].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .averagePriceadults &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "averagePriceadults")
                                  }
                                  onChange={(e) =>
                                    onChange("averagePriceadults", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {ToolStore.numbersToTest.w25 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="averagePriceteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  suffix={averagePriceItems[1].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .averagePriceteens && "roi--input-default"
                                  }
                                  onBlur={(e) => onBlur(e, "averagePriceteens")}
                                  onChange={(e) =>
                                    onChange("averagePriceteens", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}{" "}
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {addFeeAlignersItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="addFeeAlignersTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="addFeeAligners" />
                        </span>
                      </Col>
                      {ToolStore.numbersToTest.w24 > 0 &&
                        addFeeAlignersItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="addFeeAlignersadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  addFeeAlignersItems[0].suffix &&
                                  addFeeAlignersItems[0].suffix
                                }
                                prefix={ToolStore.symbol}
                                className={
                                  !NumberOfCasesStore.changed
                                    .addFeeAlignersadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) =>
                                  onBlur(e, "addFeeAlignersadults")
                                }
                                onChange={(e) =>
                                  onChange("addFeeAlignersadults", e)
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {ToolStore.conditions.separateTeensAdults &&
                        ToolStore.numbersToTest.w25 > 0 &&
                        addFeeAlignersItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="addFeeAlignersteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  addFeeAlignersItems[0].suffix &&
                                  addFeeAlignersItems[0].suffix
                                }
                                prefix={
                                  addFeeAlignersItems[0].prefix &&
                                  addFeeAlignersItems[0].prefix
                                }
                                className={
                                  !NumberOfCasesStore.changed
                                    .addFeeAlignersadults &&
                                  "roi--input-default"
                                }
                                onBlur={(e) => onBlur(e, "addFeeAlignersteens")}
                                onChange={(e) =>
                                  onChange("addFeeAlignersteens", e)
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {addFeeAlignersItems.length > 1 && (
                      <>
                        {ToolStore.numbersToTest.w24 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="addFeeAlignersadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  suffix={addFeeAlignersItems[0].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .addFeeAlignersadults &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "addFeeAlignersadults")
                                  }
                                  onChange={(e) =>
                                    onChange("addFeeAlignersadults", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {ToolStore.numbersToTest.w25 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="addFeeAlignersteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  suffix={addFeeAlignersItems[1].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .addFeeAlignersteens &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "addFeeAlignersteens")
                                  }
                                  onChange={(e) =>
                                    onChange("addFeeAlignersteens", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };
  const bracesCasesElements = () => {
    const averagePriceBraces = toGetElement(
      "bracesCases",
      "averagePriceBraces"
    );
    const addFeeBraces = toGetElement("bracesCases", "addFeeBraces");
    const averagePriceBracesItems = toGetSubElements(averagePriceBraces);
    const addFeeBracesItems = toGetSubElements(addFeeBraces);

    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="bracesCases" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="averagePriceBracesTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="averagePriceBraces" />
                    </span>
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </Row>
                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="adults" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="averagePriceBracesadults"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={ToolStore.symbol}
                        suffix={averagePriceBracesItems[0].suffix}
                        className={
                          !NumberOfCasesStore.changed
                            .averagePriceBracesadults && "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "averagePriceBracesadults")}
                        onChange={(e) =>
                          onChange("averagePriceBracesadults", e)
                        }
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ marginTop: "1vh" }}>
                  <Col xl={2} md={2} />
                  <Col xl={14} md={12}>
                    <span className="roi--label-section roi--border-adults">
                      <FormattedMessage id="teens" />
                    </span>
                  </Col>
                  <Col xl={8} md={6}>
                    <Form.Item
                      name="averagePriceBracesteens"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        prefix={ToolStore.symbol}
                        className={
                          !NumberOfCasesStore.changed.averagePriceBracesteens &&
                          "roi--input-default"
                        }
                        onBlur={(e) => onBlur(e, "averagePriceBracesteens")}
                        onChange={(e) => onChange("averagePriceBracesteens", e)}
                        type="number"
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="addFeeBracesTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="addFeeBraces" />
                    </span>
                  </Col>
                </Row>
                <>
                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="adults" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="addFeeBracesadults"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={ToolStore.symbol}
                          suffix={addFeeBracesItems[0].suffix}
                          className={
                            !NumberOfCasesStore.changed.addFeeBracesadults &&
                            "roi--input-default"
                          }
                          onBlur={(e) => onBlur(e, "addFeeBracesadults")}
                          onChange={(e) => onChange("addFeeBracesadults", e)}
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1vh" }}>
                    <Col xl={2} md={2} />
                    <Col xl={14} md={12}>
                      <span className="roi--label-section roi--border-adults">
                        <FormattedMessage id="teens" />
                      </span>
                    </Col>
                    <Col xl={8} md={6}>
                      <Form.Item
                        name="addFeeBracesteens"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          prefix={ToolStore.symbol}
                          suffix={addFeeBracesItems[1].suffix}
                          className={
                            !NumberOfCasesStore.changed.addFeeBracesteens &&
                            "roi--input-default"
                          }
                          onBlur={(e) => onBlur(e, "addFeeBracesteens")}
                          onChange={(e) => onChange("addFeeBracesteens", e)}
                          type="number"
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }

    if (averagePriceBracesItems.length > 0 || addFeeBracesItems.length > 0) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className="roi--second-collapse-title">
                  <FormattedMessage id="bracesCases" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              {averagePriceBracesItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="averagePriceBracesTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="averagePriceBraces" />
                        </span>
                      </Col>
                      {ToolStore.numbersToTest.w28 > 0 &&
                        averagePriceBracesItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="averagePriceBracesadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                prefix={ToolStore.symbol}
                                className={
                                  !NumberOfCasesStore.changed
                                    .averagePriceBracesadults &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange("averagePriceBracesadults", e)
                                }
                                onBlur={(e) =>
                                  onBlur(e, "averagePriceBracesadults")
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}

                      {ToolStore.conditions.separateTeensAdults &&
                        ToolStore.numbersToTest.w29 > 0 &&
                        averagePriceBracesItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="averagePriceBracesteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                prefix={ToolStore.symbol}
                                className={
                                  !NumberOfCasesStore.changed
                                    .averagePriceBracesteens &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange("averagePriceBracesteens", e)
                                }
                                onBlur={(e) =>
                                  onBlur(e, "averagePriceBracesteens")
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {averagePriceBracesItems.length > 1 && (
                      <>
                        {ToolStore.numbersToTest.w28 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="averagePriceBracesadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  suffix={averagePriceBracesItems[0].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .averagePriceBracesadults &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "averagePriceBracesadults")
                                  }
                                  onChange={(e) =>
                                    onChange("averagePriceBracesadults", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {ToolStore.numbersToTest.w29 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="averagePriceBracesteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .averagePriceBracesteens &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "averagePriceBracesteens")
                                  }
                                  onChange={(e) =>
                                    onChange("averagePriceBracesteens", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}{" "}
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
              {addFeeBracesItems.length > 0 && (
                <>
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={<FormattedMessage id="addFeeBracesTooltip" />}
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="addFeeBraces" />
                        </span>
                      </Col>
                      {ToolStore.numbersToTest.w28 > 0 &&
                        addFeeBracesItems.length == 1 && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="addFeeBracesadults"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                prefix={ToolStore.symbol}
                                className={
                                  !NumberOfCasesStore.changed
                                    .addFeeBracesadults && "roi--input-default"
                                }
                                onBlur={(e) => onBlur(e, "addFeeBracesadults")}
                                onChange={(e) =>
                                  onChange("addFeeBracesadults", e)
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      {ToolStore.conditions.separateTeensAdults &&
                        ToolStore.numbersToTest.w29 > 0 &&
                        addFeeBracesItems.length == 1 &&
                        addFeeBracesItems[0].fieldName ==
                          "addFeeBracesteens" && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="addFeeBracesteens"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                prefix={ToolStore.symbol}
                                prefix={
                                  addFeeBracesItems[0].prefix &&
                                  addFeeBracesItems[0].prefix
                                }
                                className={
                                  !NumberOfCasesStore.changed
                                    .addFeeBracesteens && "roi--input-default"
                                }
                                onBlur={(e) => onBlur(e, "addFeeBracesteens")}
                                onChange={(e) =>
                                  onChange("addFeeBracesteens", e)
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                    </Row>
                    {addFeeBracesItems.length > 1 && (
                      <>
                        {ToolStore.numbersToTest.w28 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="adults" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="addFeeBracesadults"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  suffix={addFeeBracesItems[0].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .addFeeBracesadults &&
                                    "roi--input-default"
                                  }
                                  onBlur={(e) =>
                                    onBlur(e, "addFeeBracesadults")
                                  }
                                  onChange={(e) =>
                                    onChange("addFeeBracesadults", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                        {ToolStore.numbersToTest.w29 > 0 && (
                          <Row style={{ marginTop: "1vh" }}>
                            <Col xl={2} md={2} />
                            <Col xl={14} md={12}>
                              <span className="roi--label-section roi--border-adults">
                                <FormattedMessage id="teens" />
                              </span>
                            </Col>
                            <Col xl={8} md={6}>
                              <Form.Item
                                name="addFeeBracesteens"
                                rules={[{ validator: dataSuperior0 }]}
                              >
                                <Input
                                  prefix={ToolStore.symbol}
                                  suffix={addFeeBracesItems[1].suffix}
                                  className={
                                    !NumberOfCasesStore.changed
                                      .addFeeBracesteens && "roi--input-default"
                                  }
                                  onBlur={(e) => onBlur(e, "addFeeBracesteens")}
                                  onChange={(e) =>
                                    onChange("addFeeBracesteens", e)
                                  }
                                  type="number"
                                ></Input>
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </Col>
                  <Col xl={2} md={0} xs={0}></Col>
                </>
              )}
            </Row>{" "}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };
  const preTreatment = () => {
    const teensYear = toGetElement("preTreatment", "teensYear");
    const whoAre = toGetElement("preTreatment", "whoAre");
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="preTreatment" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="teensYearTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="teensYear" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="teensYear"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={teensYear.suffix && teensYear.suffix}
                        prefix={teensYear.prefix && teensYear.prefix}
                        className={
                          !NumberOfCasesStore.changed.teensYear &&
                          "roi--input-default"
                        }
                        onChange={(e) => onChange("teensYear", e)}
                        onBlur={(e) => onBlur(e, "teensYear")}
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>

              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="whoAreTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="whoAre" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="whoAre"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={whoAre.suffix && whoAre.suffix}
                        prefix={whoAre.prefix && whoAre.prefix}
                        onChange={(e) => onChange("whoAre", e)}
                        onBlur={(e) => onBlur(e, "whoAre")}
                        className={
                          !NumberOfCasesStore.changed.whoAre &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    if (
      (teensYear.display && teensYear.display != -1) ||
      (whoAre.display && whoAre.display != -1)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="preTreatment" />
                </span>
              </Row>
            }
            key="1"
          >
            {((teensYear.display && teensYear.display != -1) ||
              (whoAre.display && whoAre.display != -1)) && (
              <Row>
                {teensYear.display && teensYear.display != -1 && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={<FormattedMessage id="teensYearTooltip" />}
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="teensYear" />
                          </span>
                        </Col>
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="teensYear"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={teensYear.suffix && teensYear.suffix}
                              prefix={teensYear.prefix && teensYear.prefix}
                              className={
                                !NumberOfCasesStore.changed.teensYear &&
                                "roi--input-default"
                              }
                              onChange={(e) => onChange("teensYear", e)}
                              onBlur={(e) => onBlur(e, "teensYear")}
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}

                {whoAre.display && whoAre.display != -1 && (
                  <Col xl={10} md={24} xs={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={<FormattedMessage id="whoAreTooltip" />}
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="whoAre" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="whoAre"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={whoAre.suffix && whoAre.suffix}
                            prefix={whoAre.prefix && whoAre.prefix}
                            onChange={(e) => onChange("whoAre", e)}
                            onBlur={(e) => onBlur(e, "whoAre")}
                            className={
                              !NumberOfCasesStore.changed.whoAre &&
                              "roi--input-default"
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
            )}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };

  const cost = () => {
    const averageSpend = toGetElement("cost", "averageSpend");
    const ppe = toGetElement("cost", "ppe");
    const doctorCostHour = toGetElement("cost", "doctorCostHour");
    const stafCostHour = toGetElement("cost", "stafCostHour");
    const stafCostHourItems = toGetSubElements(stafCostHour);

    const leadToFirstConsult = toGetElement("cost", "leadToFirstConsult");
    const caseAcceptanceRate = toGetElement("cost", "caseAcceptanceRate");
    var display = false;
    if (displayAll) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="cost" />
                </span>
              </Row>
            }
            key="1"
          >
            <Row>
              <>
                {" "}
                <Col xl={10} md={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={<FormattedMessage id="averageSpendTooltip" />}
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="averageSpend" />
                      </span>
                    </Col>
                    <Col md={6} xl={8}>
                      <Form.Item
                        name="averageSpend"
                        rules={[{ validator: dataSuperior0 }]}
                      >
                        <Input
                          type="number"
                          suffix={averageSpend.suffix && averageSpend.suffix}
                          prefix={ToolStore.symbol}
                          className={
                            !NumberOfCasesStore.changed.averageSpend &&
                            "roi--input-default"
                          }
                          onChange={(e) => onChange("averageSpend", e)}
                          onBlur={(e) => onBlur(e, "averageSpend")}
                        ></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col xl={2} md={0} xs={0}></Col>
              </>

              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="ppeTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="ppe" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="ppe"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={ppe.suffix && ppe.suffix}
                        prefix={ToolStore.symbol}
                        onChange={(e) => onChange("ppe", e)}
                        onBlur={(e) => onBlur(e, "ppe")}
                        className={
                          !NumberOfCasesStore.changed.ppe &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <>
                <Col xl={10} md={24}>
                  <Row>
                    <Col xl={2} md={2}>
                      <Tooltip
                        color="#EBEBEA"
                        fontFamily="Gotham"
                        fontSize="20px"
                        style={{ textColor: "#6a6e80" }}
                        placement="rightTop"
                        title={<FormattedMessage id="stafCostHourTooltip" />}
                      >
                        <img src="/images/icons/bull.svg" />
                      </Tooltip>
                    </Col>
                    <Col md={12} xl={14}>
                      <span
                        className="roi--label-section"
                        style={{ marginTop: "10px" }}
                      >
                        <FormattedMessage id="stafCostHour" />
                      </span>
                    </Col>
                  </Row>

                  <>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col xl={2} md={2} />
                      <Col xl={14} md={12}>
                        <span className="roi--label-section roi--border-adults">
                          <FormattedMessage id="dentalAssistant" />
                        </span>
                      </Col>
                      <Col xl={8} md={6}>
                        <Form.Item
                          name="stafCostHourdentalAssistant"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            prefix={ToolStore.symbol}
                            suffix={stafCostHourItems[0].suffix}
                            className={
                              !NumberOfCasesStore.changed
                                .stafCostHourdentalAssistant &&
                              "roi--input-default"
                            }
                            onBlur={(e) =>
                              onBlur(e, "stafCostHourdentalAssistant")
                            }
                            onChange={(e) =>
                              onChange("stafCostHourdentalAssistant", e)
                            }
                            type="number"
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row style={{ marginTop: "1vh" }}>
                      <Col xl={2} md={2} />
                      <Col xl={14} md={12}>
                        <span className="roi--label-section roi--border-adults">
                          <FormattedMessage id="treatmentCoordinator" />
                        </span>
                      </Col>
                      <Col xl={8} md={6}>
                        <Form.Item
                          name="stafCostHourtreatmentCoordinator"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            prefix={ToolStore.symbol}
                            suffix={stafCostHourItems[1].suffix}
                            className={
                              !NumberOfCasesStore.changed
                                .stafCostHourtreatmentCoordinator &&
                              "roi--input-default"
                            }
                            onBlur={(e) =>
                              onBlur(e, "stafCostHourtreatmentCoordinator")
                            }
                            onChange={(e) =>
                              onChange("stafCostHourtreatmentCoordinator", e)
                            }
                            type="number"
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col xl={2} md={2} />
                      <Col xl={14} md={12}>
                        <span className="roi--label-section roi--border-adults">
                          <FormattedMessage id="frontDesk" />
                        </span>
                      </Col>
                      <Col xl={8} md={6}>
                        <Form.Item
                          name="stafCostHourfrontDesk"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            prefix={ToolStore.symbol}
                            suffix={stafCostHourItems[2].suffix}
                            className={
                              !NumberOfCasesStore.changed
                                .stafCostHourfrontDesk && "roi--input-default"
                            }
                            onBlur={(e) => onBlur(e, "stafCostHourfrontDesk")}
                            onChange={(e) =>
                              onChange("stafCostHourfrontDesk", e)
                            }
                            type="number"
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </>
                </Col>
                <Col xl={2} md={0} xs={0}></Col>
              </>

              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={<FormattedMessage id="doctorCostHourTooltip" />}
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="doctorCostHour" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="doctorCostHour"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={doctorCostHour.suffix && doctorCostHour.suffix}
                        prefix={ToolStore.symbol}
                        className={
                          !NumberOfCasesStore.changed.doctorCostHour &&
                          "roi--input-default"
                        }
                        onChange={(e) => onChange("doctorCostHour", e)}
                        onBlur={(e) => onBlur(e, "doctorCostHour")}
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col xl={10} md={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="leadToFirstConsultTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="leadToFirstConsult" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="leadToFirstConsult"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          leadToFirstConsult.suffix && leadToFirstConsult.suffix
                        }
                        prefix={
                          leadToFirstConsult.prefix && leadToFirstConsult.prefix
                        }
                        className={
                          !NumberOfCasesStore.changed.leadToFirstConsult &&
                          "roi--input-default"
                        }
                        onChange={(e) => onChange("leadToFirstConsult", e)}
                        onBlur={(e) => onBlur(e, "leadToFirstConsult")}
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col xl={2} md={0} xs={0}></Col>{" "}
              <Col xl={10} md={24} xs={24}>
                <Row>
                  <Col xl={2} md={2}>
                    <Tooltip
                      color="#EBEBEA"
                      fontFamily="Gotham"
                      fontSize="20px"
                      style={{ textColor: "#6a6e80" }}
                      placement="rightTop"
                      title={
                        <FormattedMessage id="caseAcceptanceRateTooltip" />
                      }
                    >
                      <img src="/images/icons/bull.svg" />
                    </Tooltip>
                  </Col>
                  <Col md={12} xl={14}>
                    <span
                      className="roi--label-section"
                      style={{ marginTop: "10px" }}
                    >
                      <FormattedMessage id="caseAcceptanceRate" />
                    </span>
                  </Col>
                  <Col md={6} xl={8}>
                    <Form.Item
                      name="caseAcceptanceRate"
                      rules={[{ validator: dataSuperior0 }]}
                    >
                      <Input
                        type="number"
                        suffix={
                          caseAcceptanceRate.suffix && caseAcceptanceRate.suffix
                        }
                        prefix={
                          caseAcceptanceRate.prefix && caseAcceptanceRate.prefix
                        }
                        onChange={(e) => onChange("caseAcceptanceRate", e)}
                        onBlur={(e) => onBlur(e, "caseAcceptanceRate")}
                        className={
                          !NumberOfCasesStore.changed.caseAcceptanceRate &&
                          "roi--input-default"
                        }
                      ></Input>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Panel>
        </Collapse>
      );
    }
    if (
      (averageSpend.display && averageSpend.display != -1) ||
      (ppe.display != -1 && ppe.display)
    ) {
      display = true;
    }
    var displayLead = false;
    if (
      (leadToFirstConsult.display && leadToFirstConsult.display != -1) ||
      (caseAcceptanceRate.display != -1 && caseAcceptanceRate.display)
    ) {
      displayLead = true;
    }
    if (
      (averageSpend.display && averageSpend.display != -1) ||
      (ppe.display && ppe.display != -1) ||
      (ToolStore.conditions.showHourly && stafCostHourItems.length > 0) ||
      (leadToFirstConsult.display && leadToFirstConsult.display != -1) ||
      (caseAcceptanceRate.display && caseAcceptanceRate.display != -1) ||
      (doctorCostHour.display && doctorCostHour.display != -1)
    ) {
      return (
        <Collapse defaultActiveKey={["1"]}>
          <Panel
            header={
              <Row className="dashed" style={{ marginTop: "2vh" }}>
                <span className=" roi--second-collapse-title">
                  <FormattedMessage id="cost" />
                </span>
              </Row>
            }
            key="1"
          >
            {display && (
              <Row>
                {averageSpend.display && averageSpend.display != -1 && (
                  <>
                    {" "}
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="averageSpendTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="averageSpend" />
                          </span>
                        </Col>
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="averageSpend"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                averageSpend.suffix && averageSpend.suffix
                              }
                              prefix={ToolStore.symbol}
                              className={
                                !NumberOfCasesStore.changed.averageSpend &&
                                "roi--input-default"
                              }
                              onChange={(e) => onChange("averageSpend", e)}
                              onBlur={(e) => onBlur(e, "averageSpend")}
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
                {ppe.display && ppe.display != -1 && (
                  <Col xl={10} md={24} xs={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={<FormattedMessage id="ppeTooltip" />}
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="ppe" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="ppe"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={ppe.suffix && ppe.suffix}
                            prefix={ToolStore.symbol}
                            onChange={(e) => onChange("ppe", e)}
                            onBlur={(e) => onBlur(e, "ppe")}
                            className={
                              !NumberOfCasesStore.changed.ppe &&
                              "roi--input-default"
                            }
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
            )}
            <Row>
              {ToolStore.conditions.showHourly &&
                stafCostHourItems.length > 0 &&
                !ToolStore.conditions.separateStaffRole && (
                  <>
                    <Col xl={10} md={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="stafCostHourTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="stafCostHour" />
                          </span>
                        </Col>
                        {!ToolStore.conditions.separateStaffRole && (
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="stafCostHourdentalAssistant"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  stafCostHourItems[0].suffix &&
                                  stafCostHourItems[0].suffix
                                }
                                prefix={ToolStore.symbol}
                                className={
                                  !NumberOfCasesStore.changed
                                    .stafCostHourdentalAssistant &&
                                  "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange("stafCostHourdentalAssistant", e)
                                }
                                onBlur={(e) =>
                                  onBlur(e, "stafCostHourdentalAssistant")
                                }
                              ></Input>
                            </Form.Item>
                          </Col>
                        )}
                      </Row>
                      {ToolStore.conditions.separateStaffRole &&
                        stafCostHourItems.length > 1 && (
                          <>
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="dentalAssistant" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="stafCostHourdentalAssistant"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={ToolStore.symbol}
                                    suffix={stafCostHourItems[0].suffix}
                                    className={
                                      !NumberOfCasesStore.changed
                                        .stafCostHourdentalAssistant &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(e, "stafCostHourdentalAssistant")
                                    }
                                    onChange={(e) =>
                                      onChange("stafCostHourdentalAssistant", e)
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>

                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="treatmentCoordinator" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="stafCostHourtreatmentCoordinator"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={ToolStore.symbol}
                                    suffix={stafCostHourItems[1].suffix}
                                    className={
                                      !NumberOfCasesStore.changed
                                        .stafCostHourtreatmentCoordinator &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(
                                        e,
                                        "stafCostHourtreatmentCoordinator"
                                      )
                                    }
                                    onChange={(e) =>
                                      onChange(
                                        "stafCostHourtreatmentCoordinator",
                                        e
                                      )
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                            <Row style={{ marginTop: "1vh" }}>
                              <Col xl={2} md={2} />
                              <Col xl={14} md={12}>
                                <span className="roi--label-section roi--border-adults">
                                  <FormattedMessage id="frontDesk" />
                                </span>
                              </Col>
                              <Col xl={8} md={6}>
                                <Form.Item
                                  name="stafCostHourfrontDesk"
                                  rules={[{ validator: dataSuperior0 }]}
                                >
                                  <Input
                                    prefix={ToolStore.symbol}
                                    suffix={stafCostHourItems[2].suffix}
                                    className={
                                      !NumberOfCasesStore.changed
                                        .stafCostHourfrontDesk &&
                                      "roi--input-default"
                                    }
                                    onBlur={(e) =>
                                      onBlur(e, "stafCostHourfrontDesk")
                                    }
                                    onChange={(e) =>
                                      onChange("stafCostHourfrontDesk", e)
                                    }
                                    type="number"
                                  ></Input>
                                </Form.Item>
                              </Col>
                            </Row>
                          </>
                        )}
                    </Col>
                    <Col xl={2} md={0} xs={0}></Col>
                  </>
                )}
              {ToolStore.conditions.showHourly &&
                doctorCostHour.display &&
                doctorCostHour.display != -1 && (
                  <Col xl={10} md={24}>
                    <Row>
                      <Col xl={2} md={2}>
                        <Tooltip
                          color="#EBEBEA"
                          fontFamily="Gotham"
                          fontSize="20px"
                          style={{ textColor: "#6a6e80" }}
                          placement="rightTop"
                          title={
                            <FormattedMessage id="doctorCostHourTooltip" />
                          }
                        >
                          <img src="/images/icons/bull.svg" />
                        </Tooltip>
                      </Col>
                      <Col md={12} xl={14}>
                        <span
                          className="roi--label-section"
                          style={{ marginTop: "10px" }}
                        >
                          <FormattedMessage id="doctorCostHour" />
                        </span>
                      </Col>
                      <Col md={6} xl={8}>
                        <Form.Item
                          name="doctorCostHour"
                          rules={[{ validator: dataSuperior0 }]}
                        >
                          <Input
                            type="number"
                            suffix={
                              doctorCostHour.suffix && doctorCostHour.suffix
                            }
                            prefix={ToolStore.symbol}
                            className={
                              !NumberOfCasesStore.changed.doctorCostHour &&
                              "roi--input-default"
                            }
                            onChange={(e) => onChange("doctorCostHour", e)}
                            onBlur={(e) => onBlur(e, "doctorCostHour")}
                          ></Input>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                )}
            </Row>
            {displayLead && (
              <Row>
                {leadToFirstConsult.display &&
                  leadToFirstConsult.display != -1 && (
                    <>
                      <Col xl={10} md={24}>
                        <Row>
                          <Col xl={2} md={2}>
                            <Tooltip
                              color="#EBEBEA"
                              fontFamily="Gotham"
                              fontSize="20px"
                              style={{ textColor: "#6a6e80" }}
                              placement="rightTop"
                              title={
                                <FormattedMessage id="leadToFirstConsultTooltip" />
                              }
                            >
                              <img src="/images/icons/bull.svg" />
                            </Tooltip>
                          </Col>
                          <Col md={12} xl={14}>
                            <span
                              className="roi--label-section"
                              style={{ marginTop: "10px" }}
                            >
                              <FormattedMessage id="leadToFirstConsult" />
                            </span>
                          </Col>
                          <Col md={6} xl={8}>
                            <Form.Item
                              name="leadToFirstConsult"
                              rules={[{ validator: dataSuperior0 }]}
                            >
                              <Input
                                type="number"
                                suffix={
                                  leadToFirstConsult.suffix &&
                                  leadToFirstConsult.suffix
                                }
                                prefix={
                                  leadToFirstConsult.prefix &&
                                  leadToFirstConsult.prefix
                                }
                                className={
                                  !NumberOfCasesStore.changed
                                    .leadToFirstConsult && "roi--input-default"
                                }
                                onChange={(e) =>
                                  onChange("leadToFirstConsult", e)
                                }
                                onBlur={(e) => onBlur(e, "leadToFirstConsult")}
                              ></Input>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                      <Col xl={2} md={0} xs={0}></Col>{" "}
                    </>
                  )}

                {caseAcceptanceRate.display &&
                  caseAcceptanceRate.display != -1 && (
                    <Col xl={10} md={24} xs={24}>
                      <Row>
                        <Col xl={2} md={2}>
                          <Tooltip
                            color="#EBEBEA"
                            fontFamily="Gotham"
                            fontSize="20px"
                            style={{ textColor: "#6a6e80" }}
                            placement="rightTop"
                            title={
                              <FormattedMessage id="caseAcceptanceRateTooltip" />
                            }
                          >
                            <img src="/images/icons/bull.svg" />
                          </Tooltip>
                        </Col>
                        <Col md={12} xl={14}>
                          <span
                            className="roi--label-section"
                            style={{ marginTop: "10px" }}
                          >
                            <FormattedMessage id="caseAcceptanceRate" />
                          </span>
                        </Col>
                        <Col md={6} xl={8}>
                          <Form.Item
                            name="caseAcceptanceRate"
                            rules={[{ validator: dataSuperior0 }]}
                          >
                            <Input
                              type="number"
                              suffix={
                                caseAcceptanceRate.suffix &&
                                caseAcceptanceRate.suffix
                              }
                              prefix={
                                caseAcceptanceRate.prefix &&
                                caseAcceptanceRate.prefix
                              }
                              onChange={(e) =>
                                onChange("caseAcceptanceRate", e)
                              }
                              onBlur={(e) => onBlur(e, "caseAcceptanceRate")}
                              className={
                                !NumberOfCasesStore.changed
                                  .caseAcceptanceRate && "roi--input-default"
                              }
                            ></Input>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  )}
              </Row>
            )}
          </Panel>
        </Collapse>
      );
    } else {
      return "";
    }
  };

  const toDisplayNumberOfCases = () => {
    if (
      generalElements() != "" ||
      (ToolStore.numbersToTest.w24 + ToolStore.numbersToTest.w25 > 0 &&
        alignerCasesElements() != "") ||
      (ToolStore.numbersToTest.w28 + ToolStore.numbersToTest.w29 > 0 &&
        bracesCasesElements() != "") ||
      preTreatment() != "" ||
      cost() != ""
    ) {
      return true;
    } else {
      return false || displayAll;
    }
  };
  const toDisplayAligners = () => {};
  return (
    <>
      {toDisplayNumberOfCases() && (
        <Form
          form={form}
          onChange={() =>
            NumberOfCasesStore.toUpdateNumberOfCases(form.getFieldsValue())
          }
        >
          <CollapseComponent
            style={{ marginBottom: "2vh", marginTop: "2vh" }}
            headerText={<FormattedMessage id="numberOfCases" />}
            classNameHeader="roi--collapse-header-green"
            content={
              NumberOfCasesStore.data != null && (
                <>
                  {generalElements()}

                  {displayAll ||
                  ToolStore.numbersToTest.w24 + ToolStore.numbersToTest.w25 > 0
                    ? alignerCasesElements()
                    : ""}
                  {displayAll ||
                  ToolStore.numbersToTest.w28 + ToolStore.numbersToTest.w29 > 0
                    ? bracesCasesElements()
                    : ""}
                  {preTreatment()}
                  {cost()}
                </>
              )
            }
          ></CollapseComponent>
        </Form>
      )}
    </>
  );
};

export default inject("ToolStore")(observer(NumberOfCases));
